import { HeadCell } from 'models';
import { PACKAGE_TYPE } from 'models/package';

export const headCells: readonly HeadCell<PACKAGE_TYPE>[] = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Package Name',
  },
  {
    id: 'description',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Description',
  },
  {
    id: 'parent_rate',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'Parent Rate',
  },
  {
    id: 'sitter_rate',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'Sitter Rate',
  },
  {
    id: 'price',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Price',
  },
  {
    id: 'tag',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Most Popular',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Created Date',
  },
];
